import { Keys } from "@pjs/core-ui";
import { withDigest } from "../react2angular/utilities/WithDigest.function";

export const getFeedbackListShortcuts = (element, services) => {
    return [
        {
            keys: [Keys.Control, Keys.Shift, "k"],
            callback: withDigest(() => element.querySelector(`[data-hook='feedback-search-input']`)?.focus(), services.scope),
            description: services.multiLangService.getString("shortcuts.start_keyword_search")
        }
    ];
};
